import React, { useState } from "react";
import styles from "./Search.module.scss";
import search from "assets/img/search.png";
import ResetFilter from "components/Filter/ResetFilter/ResetFilter";

const Search = props => {
    const [timer, setTimer] = useState();
    const { filterText, setFilterText } = props;
    return (
        <div className={styles.searchContainer}>
            <div className={styles.search}>
                <div className={styles.icon}>
                    <img src={search} alt="Busca" />
                </div>
                <div className={styles.input}>
                    <input
                        type="text"
                        value={filterText}
                        placeholder="O que você procura?"
                        onChange={({ target: { value } }) => {
                            clearTimeout(timer);
                            setFilterText(value);
                            setTimer(
                                setTimeout(() => {
                                    props.filtrar(value);
                                }, 1250)
                            );
                            props.setIsSeenOnMap(false);
                            props.setZoom(14);
                        }}
                    />
                    {filterText && filterText.length > 0 ? (
                        <ResetFilter
                            filtrar={() => {
                                setFilterText("");
                                props.filtrar(null);
                                props.setIsSeenOnMap(false);
                                props.setZoom(14);
                            }}
                        />
                    ) : null}
                </div>
            </div>
        </div>
    );
};

export default Search;